import { render, staticRenderFns } from "./bom.vue?vue&type=template&id=f6a714fe&scoped=true"
import script from "./bom.vue?vue&type=script&lang=js"
export * from "./bom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a714fe",
  null
  
)

export default component.exports